 import React from "react";
import Navbar from "../../components/Navbar";
import SecondNavbar from "../../components/SecondNavbar";
import Footer from "../../components/Footer";
import "./Airtype.css";

import indoorImg from "../../assets/indoor1.jpg";
import smogImg from "../../assets/outdoor.jpg";
import industryImg from "../../assets/industry.jpg";
import vehicleImg from "../../assets/vehicle1.jpg";
import chemicalImg from "../../assets/chemical.jpg";

const PollutionTypes = () => {
  return (
    <>
      <Navbar />
      <SecondNavbar />

      <div className="pollution-wrapper">

        <section className="hero-section">

          <div className="hero-content">

            <span className="hero-tag">
              Environmental Awareness
            </span>

            <h1>Types of Air Pollution</h1>

            <p>
              Air pollution is one of the biggest environmental threats today.
              Harmful gases, smoke, and toxic particles affect human health,
              climate, and ecosystems around the world.
            </p>

          </div>

        </section>

        <section className="intro-section">

          <h2>Understanding Air Pollution</h2>

          <p>
            Air pollution happens when harmful substances contaminate the air.
            These pollutants come from homes, factories, vehicles, chemicals,
            and industrial activities.
          </p>

        </section>

        <section className="pollution-section">

          <div className="pollution-image">
            <img
              src={indoorImg}
              alt="Indoor Pollution"
            />
          </div>

          <div className="pollution-content">

            <h1>Indoor Pollution</h1>

            <p>
              Indoor pollution refers to harmful contamination of air inside homes,
              offices, schools, and closed buildings.
            </p>

            <p>
              Smoke, poor ventilation, and household chemicals can slowly damage
              indoor air quality and human health.
            </p>

            <div className="detail-box">
              <h4>Common Sources</h4>
              <p>Cooking smoke, cleaning sprays, cigarette smoke</p>
            </div>

            <div className="detail-box">
              <h4>Health Effects</h4>
              <p>Asthma, coughing, headaches, breathing issues</p>
            </div>

          </div>

        </section>

        <section className="pollution-section reverse">

          <div className="pollution-image">
            <img
              src={smogImg}
              alt="Urban Smog"
            />
          </div>

          <div className="pollution-content">

            <h1>Urban Smog</h1>

            <p>
              Urban smog forms when smoke, fog, dust, and harmful gases
              combine together in crowded cities.
            </p>

            <p>
              Heavy traffic and industrial smoke increase smog levels
              and create unhealthy breathing conditions.
            </p>

            <div className="detail-box">
              <h4>Main Causes</h4>
              <p>Vehicle emissions and industrial smoke</p>
            </div>

            <div className="detail-box">
              <h4>Effects</h4>
              <p>Lung infections and respiratory diseases</p>
            </div>

          </div>

        </section>

        <section className="pollution-section">

          <div className="pollution-image">
            <img
              src={industryImg}
              alt="Industrial Pollution"
            />
          </div>

          <div className="pollution-content">

            <h1>Industrial Pollution</h1>

            <p>
              Factories and manufacturing plants release toxic gases,
              smoke, and harmful particles into the atmosphere.
            </p>

            <p>
              Industrial pollution contributes to environmental imbalance,
              acid rain, and climate change.
            </p>

            <div className="detail-box">
              <h4>Main Sources</h4>
              <p>Factory smoke and chemical waste gases</p>
            </div>

            <div className="detail-box">
              <h4>Effects</h4>
              <p>Toxic air and environmental damage</p>
            </div>

          </div>

        </section>

        <section className="pollution-section reverse">

          <div className="pollution-image">
            <img
              src={vehicleImg}
              alt="Vehicle Emissions"
            />
          </div>

          <div className="pollution-content">

            <h1>Vehicle Emissions</h1>

            <p>
              Cars, buses, and motorcycles release dangerous gases
              through fuel combustion and exhaust systems.
            </p>

            <p>
              Vehicle pollution increases carbon emissions and contributes
              to global warming and poor air quality.
            </p>

            <div className="detail-box">
              <h4>Main Pollutants</h4>
              <p>Carbon monoxide and nitrogen oxides</p>
            </div>

            <div className="detail-box">
              <h4>Effects</h4>
              <p>Respiratory diseases and climate change</p>
            </div>

          </div>

        </section>

        <section className="pollution-section">

          <div className="pollution-image">
            <img
              src={chemicalImg}
              alt="Chemical Pollution"
            />
          </div>

          <div className="pollution-content">

            <h1>Chemical Pollution</h1>

            <p>
              Chemical pollution occurs when toxic chemicals,
              sprays, and hazardous gases mix with air.
            </p>

            <p>
              Many chemical pollutants are invisible but can slowly
              damage lungs, skin, and overall human health.
            </p>

            <div className="detail-box">
              <h4>Main Sources</h4>
              <p>Toxic sprays and hazardous industrial gases</p>
            </div>

            <div className="detail-box">
              <h4>Effects</h4>
              <p>Skin irritation and lung damage</p>
            </div>

          </div>

        </section>

      </div>

      <Footer />
    </>
  );
};

export default PollutionTypes;